import React from 'react';
import { observer } from "mobx-react";
import {Button} from 'antd';
import {supportedLanguages} from '../../stores/objects/I18n';

const langLink = (language, store, isLast) => {
     let disabled= language.key === store.state.language;
    return (
        <span key={language.key}>
        <Button className={(disabled ? " CSUS-SE-btn-disabled " : "") + "CSUS-SE-lang-picker-btn CSUS-SE-btn"}
            key={language.key}
            type="link" 
            onClick={() => 
                store.changeLanguage(language.key)}
            disabled={disabled} 
        > {language.nativeName}
        </Button>
        {isLast ? "" : "/"}
        </span>
    )
}


const LanguagePicker = observer(({store}) => {
    return (
        <span>
            {supportedLanguages.map((l, i) => langLink(l, store, (i+1)===(supportedLanguages.length)))}
        </span>
    ) 
    
});

export default LanguagePicker;